module.exports = function getResource(label, vars = []) {
    let resources = {
        goingFast: 'Going Fast',
        limitedSupply: 'Limited Supply',
        viewFullSize: 'View Full Size',
        viewDetails: 'View Details',
        remove: 'Remove',
        addToBasket: 'Add to Basket',
        quickLook: 'Quick Look',
        productPreview: 'Product Preview',
        free: 'Free'
    };

    return resources[label];
};
